<template>
  <el-popover width="260" popper-class="template-pic-selector" trigger="click">
    <div class="item-list" v-ps>
      <img
        v-for="i in 24"
        :key="i"
        :src="getUri(i) + '?x-oss-process=image/resize,w_50'"
        :class="['pointer', i === selectedIndex ? 'selected' : '']"
        @click="select(i)"
      />
    </div>
    <span slot="reference" class="pointer" style="color: #1989FA;">
      更换图标
    </span>
  </el-popover>
</template>
<script>
export default {
  name: "template-pic-selector",
  props: {
    value: String
  },
  computed: {
    selectedIndex() {
      if (!this.value) return 1
      let startI = this.value.lastIndexOf("/")
      let dotI = this.value.lastIndexOf(".")
      if (startI < 0 || dotI < 0 || dotI <= startI) return 1
      return this._.toNumber(this.value.substring(startI + 1, dotI))
    }
  },
  data() {
    return {
      prefix: "https://new-service.oss-cn-hangzhou.aliyuncs.com/app-template/"
    }
  },
  methods: {
    select(i) {
      this.$emit("input", this.getUri(i))
    },
    getUri(i) {
      return `${this.prefix}${i < 10 ? "0" + i : i}.jpg`
    }
  }
}
</script>

<style lang="scss" scoped>
.template-pic-selector {
  .item-list {
    padding: 3px;
    display: flex;
    flex-wrap: wrap;
    img {
      width: 50px;
      margin: 6px;
      &.selected {
        box-shadow: 0 0 5px 1px #198afa;
      }
    }
  }
}
</style>
